import type { PeopleSlice } from '../bs/people'

/**
 * English for one person's page and the Dnevnik's additions.
 *
 * Complete, not partial — see en/index.ts. "Report" for *prijava* and
 * "sign-in" for *prijava u sistem*, the two words Bosnian spells alike, and
 * "main administrator" for *glavni administrator*, as on the People screen.
 */
export const people: PeopleSlice = {
  'crumb.person': 'Person',

  'people.loading': 'Loading the person…',
  'people.back': 'Users',
  'people.forbidden.title': 'You cannot open this person',
  'people.missing.title': 'This person does not exist',
  'people.missing.description':
    'They may have been deleted in the meantime. Look them up on the users list.',
  'people.status.active': 'Active',
  'people.plants': 'Plants:',
  'people.lastSignIn': 'Last sign-in',
  'people.method.password': 'with a password',
  'people.method.badge': 'with a QR badge',
  'people.mes.id': 'KaproMES ID {id}',
  'people.mes.open': 'Open the KaproMES integration',
  'people.mes.unfollowed': 'No longer sent by KaproMES',
  'people.mes.unfollowed.explain':
    'KaproMES stopped sending this person on {when}. The account was left as it was — deactivate it here if they have left.',

  'people.action.edit': 'Edit',
  'people.action.activate': 'Activate',
  'people.action.deactivate': 'Deactivate',
  'people.action.deactivate.self': 'You cannot deactivate your own account.',
  'people.action.code': 'Issue a code',
  'people.action.badge': 'Badge',
  'people.action.badge.inactive': 'A badge can only be issued to an active account.',
  'people.activate.confirm': 'Activate the account of "{name}"?',
  'people.activate.body': 'They can sign in again with the same password or badge as before.',
  'people.deactivate.confirm': 'Deactivate the account of "{name}"?',
  'people.deactivate.body':
    'They are signed out of every device at once and cannot sign in until you activate the account again. Their reports, tasks and walks stay.',
  'people.activated': 'The account has been activated.',
  'people.deactivated': 'The account has been deactivated.',
  'people.save.failed': 'The change was not saved. Please try again.',

  'people.summary': 'Summary',
  'people.tile.reports': 'Reports',
  'people.tile.reports.detail': 'Open: {open}',
  'people.tile.tasks': 'Tasks',
  'people.tile.tasks.detail': 'Done: {done} · overdue: {overdue}',
  'people.tile.walks': '5S walks',
  'people.tile.walks.detail': 'On centres they keep: {kept}',
  'people.tile.rating': 'Rating',
  'people.tile.rating.detail': '{position} of {ranked} · {month}',
  'people.tile.rating.unranked': 'Not ranked · {month}',
  'people.tile.rating.none': 'No rating yet this month',
  'people.tile.rating.thin': 'Based on few walks — a rough guide only.',
  'people.tile.signIns': 'Sign-ins, last 30 days',
  'people.tile.signIns.detail': 'Failed: {failed}',
  'people.tile.scope': 'Only work in your plants is counted.',

  'people.activity.title': 'Activity',
  'people.activity.explain':
    '"Account" is changes to this person\'s account, whoever made them. "Actions" is what this person did themselves — in administration, on reports and on checklists. Reports, tasks and walks come only from the plants you can see.',
  'people.activity.filter.label': 'Kind of activity',
  'people.activity.filter.sve': 'All',
  'people.activity.filter.prijava-u-sistem': 'Sign-ins',
  'people.activity.filter.prijave': 'Reports',
  'people.activity.filter.zadaci': 'Tasks',
  'people.activity.filter.5s': '5S',
  'people.activity.filter.nalog': 'Account',
  'people.activity.filter.radnje': 'Actions',
  'people.activity.empty.title': 'No activity',
  'people.activity.empty.description':
    'Sign-ins, reports, tasks, 5S walks and account changes appear here.',
  'people.activity.empty.filter': 'Nothing of this kind yet.',
  'people.activity.shown': 'Showing {shown} of {total}',
  'people.activity.loadMore': 'Load more',
  'people.activity.ip': 'IP {ip}',
  'people.activity.ip.explain':
    'The address the sign-in came from. Only the main administrator sees it.',

  'admin.log.filter.causer.noMatch': 'Nobody by that name in the log',
  'admin.log.export': 'Export (Excel)',
  'admin.log.export.explain':
    'The same entries as on screen, with the same filters — the newest 10,000 at most.',
  'admin.log.chips.label': 'Filters in use',
  'admin.log.chip.search': 'Search: "{value}"',
  'admin.log.chip.causerId': 'Person: {value}',
  'admin.log.chip.subjectType': 'What: {value}',
  'admin.log.chip.event': 'Change: {value}',
  'admin.log.chip.logName': 'Entry type: {value}',
  'admin.log.chip.from': 'From {value}',
  'admin.log.chip.to': 'To {value}',
  'admin.log.chip.remove': 'Remove filter: {label}',
}
